<template>
  <div class="activity-duration">
    <div class="activity-duration__title">
      <p>Durasi Aktivitas</p>
      <i
        id="activity-duration-tooltip"
        class="float-end input-tooltip-btn"
        :class="{
          'icon-outline_info': !isHover,
          'icon-fill_info': isHover,
        }"
        @mouseenter="isHover = true"
        @mouseleave="isHover = false"
      ></i>

      <b-tooltip target="activity-duration-tooltip" triggers="hover" placement="right">
        Rata-rata durasi aktivitas ambil atau kirim
      </b-tooltip>
    </div>

    <div v-for="field in fields" :key="field.key" class="row">
      <div class="activity-duration__section col-12 col-sm-6">
        <McRadioButton
          :id="field.radioBtn.all"
          v-model="isSelectMerge"
          class="__radio-btn"
          name="squash_duration"
          :label="field.radioBtn.label"
          :initialValue="field.radioBtn.initialValue"
          @input="() => handleInput({ key: field.key })"
        />
        <FormulateInput
          :key="`duration-${field.key}`"
          :ref="`duration-${field.key}-ref`"
          v-model="formValues[field.key]"
          class="__duration-input"
          label=""
          ignored
          type="time-duration"
          placeholder="00 Jam 00 Menit"
          :initialValues="initDurationValues"
          :disabled="field.key === 'all' ? isSelectMergeBtnDisabled : !isSelectMergeBtnDisabled"
          :optionItems="optionItems"
          validation="isoTimeGteValue:PT3M"
          validation-behavior="live"
          error-behavior="live"
          @input="() => handleDurationInput({ key: field.key })"
        />
      </div>
    </div>
  </div>
</template>

<script>
import McRadioButton from '@/components/McRadioButton'

export default {
  components: {
    McRadioButton,
  },
  props: {
    squashDuration: {
      type: Number,
      default: 2,
    },
    serviceTime: {
      type: String,
      default: 'PT15M',
    }
  },
  emits: ['update:squashDuration'],
  data() {
    return {
      isHover: false,
      isSelectMerge: true,

      formValues: {
        all: "PT15M",
        eachDO: "PT15M",
      },
      initDurationValues: {
        hours: 0,
        minutes: 15,
      },

      optionItems: [
        {
          key: 'hours',
          items: Array.from({ length: 24 }, (_, i) => i),
        },
        {
          key: 'minutes',
          items: Array.from({ length: 60 }, (_, i) => i),
        },
      ],
      fields: [
        {
          key: 'all',
          radioBtn: {
            id: 'all',
            label: 'Durasi Aktivitas Keseluruhan',
            initialValue: true,
          },
          durationInput: {
            key: 'all',
          },
        },
        {
          key: 'eachDO',
          radioBtn: {
            id: 'eachDO',
            label: 'Durasi Aktivitas per DO',
            initialValue: false,
          },
          durationInput: {
            key: 'eachDO',
          },
        },
      ],
    }
  },
  computed: {
    isSelectMergeBtnDisabled() {
      return this.isSelectMerge ? false : true
    },
  },
  watch: {
    squashDuration(newValue) {
      if (newValue === 2) {
        this.isSelectMerge = true
        return
      }

      this.isSelectMerge = false
    },
  },
  methods: {
    ResetFormValues() {
      this.formValues = {
        all: "PT15M",
        eachDO: "PT15M",
      }
    },

    handleInput({ key }) {
      // Clear validation errors once at the start
      ['all', 'eachDO'].forEach(ref => {
        this.$refs[`duration-${ref}-ref`][0].validationErrors = []
      })
      
      this.handleDurationInput({ key })
      
      // Set validation and state based on key
      const isAllKey = key === 'all'
      this.$refs[`duration-${key}-ref`][0].performValidation()
      this.isSelectMerge = isAllKey
      
      // Emit updated squash duration
      this.$emit('update:squashDuration', isAllKey ? 2 : null)
    },
    
    handleDurationInput({ key }) {
      this.$emit('update:serviceTime', this.formValues[key])
    }
  },
}
</script>

<style lang="scss" scoped>
.activity-duration {
  &__title {
    font-size: 13px;
    display: flex;
    gap: 4px;
    align-items: center;

    p {
      margin: 0;
    }
  }

  &__section {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;

    .__duration-input {
      width: 300px;
    }
  }
}
</style>